var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.95002C6.10552 2.95002 2.94856 6.10699 2.94856 10.0013C2.94856 13.8956 6.10552 17.0526 9.99984 17.0526C13.8942 17.0526 17.0511 13.8956 17.0511 10.0013C17.0511 6.10699 13.8942 2.95002 9.99984 2.95002ZM1.6665 10.0013C1.6665 5.39893 5.39746 1.66797 9.99984 1.66797C14.6022 1.66797 18.3332 5.39893 18.3332 10.0013C18.3332 14.6037 14.6022 18.3346 9.99984 18.3346C5.39746 18.3346 1.6665 14.6037 1.6665 10.0013ZM9.99984 5.94147C10.3539 5.94147 10.6409 6.22847 10.6409 6.5825V9.73578L13.0172 12.1121C13.2676 12.3625 13.2676 12.7683 13.0172 13.0187C12.7669 13.269 12.361 13.269 12.1107 13.0187L9.54656 10.4546C9.42635 10.3344 9.35881 10.1713 9.35881 10.0013V6.5825C9.35881 6.22847 9.64581 5.94147 9.99984 5.94147Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntClock);
export default __webpack_public_path__ + "static/media/ent-clock.fa93033d3306095cbeed90d10c96f43c.svg";
export { ForwardRef as ReactComponent };